import { render, staticRenderFns } from "./IgPaymentVoucher.vue?vue&type=template&id=4dafbb8c&"
import script from "./IgPaymentVoucher.vue?vue&type=script&lang=js&"
export * from "./IgPaymentVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports